import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import homeVideoBackground from "../../../assets/video/homepageBg.mp4";
import getVideoConfig from "../../../component/video-config/videoConfig";
import ChromaKeyVideo from "../../../component/chroma-key/chromakey";
import { VscSend } from "react-icons/vsc";

import refreshIcon from "../../../assets/images/bg-refresh-button.png";
import showMenuIcon from "../../../assets/images/bg-show-menu.png";
import fxmlogo from "../../../assets/icons/fxmedia-logo.png";
import bgPopupMessage from "../../../assets/images/bg-popup-message.png";
import Menu from "../../../component/menu/menu";
import BubbleChat from "../../../component/bubble-chat/bubbleChat";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { IoClose } from "react-icons/io5";
import { HiMiniSpeakerWave } from "react-icons/hi2";
import { login, getAuthToken } from "../../../auth/auth";
import ConnectionTest from "../../../auth/connectionTest";
import { useIdleTimer } from "react-idle-timer";
import { useConversation } from "@elevenlabs/react";
import packageJson from "../../../../package.json";
import getAudioConfig from "../../../component/audio-config/audio-config";
import DefaultStarValue from "../../../component/default-value/defaultStarValue";
import toast, { Toaster } from "react-hot-toast";

const PROD_URL = process.env.REACT_APP_BASE_URL; // use this for production
const DEV_URL = process.env.REACT_APP_DEV_URL; // use this for development

const getAgentIdForAvatar = (avatarName) => {
  const name = (avatarName || "").toLowerCase();
  switch (name) {
    case "mark":  return process.env.REACT_APP_EL_AGENT_MARK;
    case "joeie": return process.env.REACT_APP_EL_AGENT_JOEIE;
    case "dila":
    case "dilla": return process.env.REACT_APP_EL_AGENT_DILA;
    default:      return process.env.REACT_APP_ELEVENLABS_AGENT_ID;
  }
};

export default function HomePage() {
  DefaultStarValue();
  const location = useLocation();
  const currentAvatar = location.pathname.split("/").pop().toLowerCase();
  let isProduction = false;
  const BASE_URL = isProduction ? PROD_URL : DEV_URL;

  const {
    hiMessage,
    welcomeMessage,
    sorryMessage,
    glitchMessage,
    talkMessage,
    idleMessage,
    case2,
    noActivityMessage,
    hiText,
    welcomeText,
    sorryText,
    glitchText,
    case2Text,
    inActiveText,
    idleTalk,
  } = getVideoConfig();
  // const [step, setStep] = useState(() => {
  //   const savedStep = sessionStorage.getItem("step");
  //   return savedStep ? JSON.parse(savedStep) : 0;
  // });
  const [step, setStep] = useState(0);
  useEffect(() => {
    sessionStorage.removeItem("step");
    setStep(0);
  }, []);
  const [userName, setUserName] = useState(() => {
    const savedUserName = sessionStorage.getItem("userName");
    return savedUserName || "";
  });
  const [menuVisible, setMenuVisible] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [currentVideo, setCurrentVideo] = useState(idleTalk);
  const [loop, setLoop] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);
  const [messages, setMessages] = useState(() => {
    const savedMessages = sessionStorage.getItem("messages");
    return savedMessages ? JSON.parse(savedMessages) : [];
  });
  const [pendingTextMessage, setPendingTextMessage] = useState(null);
  const [inputMessage, setInputMessage] = useState("");
  const [isVoiceInputActive, setIsVoiceInputActive] = useState(false);
  const [isVoiceMessageSent, setIsVoiceMessageSent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mode, setMode] = useState("silent");
  const [audioPlayer, setAudioPlayer] = useState(null);
  const [idleStatus, setIdleStatus] = useState(false);
  const [remaining, setRemaining] = useState(0);
  const [authToken, setAuthToken] = useState("");
  const configId = useState(
    parseInt(sessionStorage.getItem("config_id"), 10) || "1"
  );
  const [micPermission, setMicPermission] = useState(null);
  const [aiResponse, setAiResponse] = useState("");
  const [limitTimer, setLimitTimer] = useState(null);
  const [videoMode, setVideoMode] = useState("idle");
  const [manualPlay, setManualPlay] = useState(false);

  const [elevenLabsTranscript, setElevenLabsTranscript] = useState("");
  const [recording, setRecording] = useState(false);
  const [elConnected, setElConnected] = useState(false);
  const [micMuted, setMicMuted] = useState(true);
  const pendingMessageRef = useRef(null);
  const sendUserMessageRef = useRef(null);

  // ----------------------------------------------------
  // ELEVENLABS USECONVERSATION HOOK
  // ----------------------------------------------------
  const conversation = useConversation({
    micMuted: micMuted,
    onConnect: () => {
      console.log("[EL] Connected");
      setElConnected(true);
      setRecording(true);
      setMessages((prev) => [...prev, { type: "system", text: "Connected" }]);
    },
    onDisconnect: () => {
      console.log("[EL] Disconnected");
      setElConnected(false);
      setRecording(false);
      setVideoMode("idle");
      setLoop(true);
      setMode("silent");
      setMessages((prev) => [...prev, { type: "system", text: "Disconnected" }]);
    },
    onError: (error) => {
      console.error("[EL] Error encountered:", typeof error === "string" ? error : JSON.stringify(error));
      setRecording(false);
      setElConnected(false);
    },
    onStatusChange: (status) => {
      console.log("[EL] onStatusChange:", status);
    },
    onModeChange: (modeInfo) => {
      console.log("[EL] onModeChange:", modeInfo.mode);
      if (modeInfo.mode === "speaking") {
        setVideoMode("talk");
        setMode("talk");
      } else if (modeInfo.mode === "listening") {
        setVideoMode("idle");
        setMode("listen");
      }
      // Ignore other modes like "thinking" to avoid premature idle reset
    },
    onMessage: (msg) => {
      console.log("[EL] onMessage raw:", msg);
      try {
        let textContent = "";
        let source = "ai";

        if (typeof msg === "string") {
          textContent = msg;
        } else if (msg && typeof msg === "object") {
          source = msg.source || msg.role || "ai";
          if (typeof msg.message === "string") textContent = msg.message;
          else if (msg.message && typeof msg.message.content === "string") textContent = msg.message.content;
          else if (typeof msg.text === "string") textContent = msg.text;
          else textContent = JSON.stringify(msg);
        }

        if (!textContent || !textContent.trim() || textContent === "{}") return;

        if (source === "user") {
          setElevenLabsTranscript(textContent);
          setIsLoading(true);
          setMessages((prev) => {
            const lastMsg = prev[prev.length - 1];
            if (lastMsg && lastMsg.type === "user" && lastMsg.text === textContent) {
              return prev;
            }
            return [...prev, { type: "user", text: textContent, userName }];
          });
        } else {
          setIsLoading(false);
          setMessages((prev) => {
            const lastMsg = prev[prev.length - 1];
            if (lastMsg && lastMsg.type === "ai" && lastMsg.text === textContent) {
              return prev; 
            }
            return [...prev, { type: "ai", text: textContent }];
          });
        }
      } catch (e) {
        console.error("[EL] onMessage parsing error:", e);
      }
    },
    onAgentChatResponsePart: (chunk) => {
      console.log("[EL] onAgentChatResponsePart chunk:", chunk);
      try {
        let textChunk = "";
        if (typeof chunk === "string") {
          textChunk = chunk;
        } else if (chunk && typeof chunk === "object") {
          if (typeof chunk.text === "string") textChunk = chunk.text;
          else if (typeof chunk.message === "string") textChunk = chunk.message;
          else textChunk = JSON.stringify(chunk);
        }
        
        if (!textChunk || !textChunk.trim() || textChunk === "{}") return;
        
        setMessages((prev) => {
          if (prev.length === 0) return [{ type: "ai", text: textChunk }];
          
          const lastMsg = prev[prev.length - 1];
          if (lastMsg.type === "user") {
            return [...prev, { type: "ai", text: textChunk }];
          }
          const updatedMsg = { ...lastMsg, text: lastMsg.text + textChunk };
          return [...prev.slice(0, -1), updatedMsg];
        });
      } catch (e) {
        console.error("[EL] onAgentChatResponsePart error:", e);
      }
    }
  });

  // Always keep the ref updated with the latest function
  useEffect(() => {
    if (conversation && conversation.sendUserMessage) {
      sendUserMessageRef.current = conversation.sendUserMessage;
    }
  }, [conversation]);

  // Text queuing disabled for testing voice first.

  // Removed manual useEffect cleanup; useConversation handles its own session lifecycle.

  useEffect(() => {
    const performLogin = async () => {
      try {
        const token = await login();
        setAuthToken(token);
      } catch (error) {
        console.error("Failed to login:", error);
      }
    };

    performLogin();
  }, []);

  const videoRef = useRef(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    if (step >= 5) {
      if (videoMode === "idle") {
        videoElement.currentTime = 0;
        videoElement.loop = false;
        videoElement.play().catch(() => {});
      } else if (videoMode === "talk") {
        videoElement.currentTime = 5.1;
        videoElement.loop = false;
        videoElement.play().catch(() => {});
      }

      const handleTimeUpdate = () => {
        if (videoMode === "idle" && videoElement.currentTime >= 4.5) {
          videoElement.currentTime = 0;
          videoElement.play().catch(() => {});
        } else if (videoMode === "talk" && videoElement.currentTime >= 17) {
          videoElement.currentTime = 5.1;
          videoElement.play().catch(() => {});
        }
      };

      videoElement.addEventListener("timeupdate", handleTimeUpdate);

      return () => {
        videoElement.removeEventListener("timeupdate", handleTimeUpdate);
      };
    }
  }, [videoMode, step]);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    let timeout;
    if (step === 2) {
      timeout = setTimeout(() => {
        handleAutoSkip();
      }, 8000);
    }

    return () => {
      clearTimeout(timeout);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [step]);

  useEffect(() => {
    if (!isOnline && step !== 2) {
      setStep(2);
    } else if (isOnline && step === 2) {
      setStep(3);
    }
  }, [isOnline]);

  const handleAutoSkip = useCallback(() => {
    setStep((prevStep) => {
      if (prevStep >= 5) return 5; // Never go past step 5 (chat mode)
      return prevStep === 4 ? 5 : prevStep + 1;
    });
  }, []);

  const handleSkip = useCallback(() => {
    setStep(4);
  }, []);

  const getMessageAndVideo = useCallback(() => {
    switch (step) {
      case 0:
        return {
          message: welcomeText,
          video: welcomeMessage,
          showSkip: true,
          showNameInput: false,
          loop: false,
        };
      case 1:
        return {
          message: case2Text,
          video: case2,
          showSkip: true,
          showNameInput: false,
          loop: false,
        };
      case 2:
        return {
          message: glitchText,
          video: glitchMessage,
          showSkip: true,
          showNameInput: false,
          loop: true,
        };
      case 3:
        return {
          message: sorryText,
          video: sorryMessage,
          showSkip: true,
          showNameInput: false,
          loop: false,
        };
      case 4:
        return {
          message: hiText,
          video: hiMessage,
          showSkip: false,
          showNameInput: true,
          loop: false,
        };
      default:
        return {
          video: idleTalk,
          showSkip: false,
          showNameInput: false,
          loop: true,
        };
    }
  }, [step]);

  useEffect(() => {
    if (videoRef.current && videoRef.current.src === idleTalk) {
      videoRef.current.currentTime = 0;

      const timeout = setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.pause();
        }
      }, 4900);

      return () => clearTimeout(timeout);
    }
  }, [idleTalk]);

  useEffect(() => {
    const { video, loop } = getMessageAndVideo();
    setFadeIn(false);
    setTimeout(() => {
      setCurrentVideo(video);
      setLoop(loop);
      setFadeIn(true);
    }, 500);
  }, [step, getMessageAndVideo]);

  const { message, showSkip, showNameInput } = getMessageAndVideo();

  const handleRefresh = useCallback(() => {
    const language = sessionStorage.getItem("language") || "English";
    const confirmationMessage =
      language === "Indonesia"
        ? "Apakah Anda yakin ingin memulai ulang?"
        : "Are you sure you want to restart?";

    toast(
      (t) => (
        <div>
          <p>{confirmationMessage}</p>
          <div
            style={{
              background: "white",
              color: "#111",
              padding: "20px 0 0 0",
              borderRadius: "12px",
              width: "320px",
              fontSize: "14px",
              gap: "10px",
            }}
          >
            <button
              onClick={() => {
                toast.dismiss(t.id);
                setTimeout(() => {
                  setMessages([]);
                  setStep(0);
                  setUserName("");
                  sessionStorage.removeItem("messages");
                  sessionStorage.removeItem("step");
                  sessionStorage.removeItem("userName");
                  sessionStorage.removeItem("videoUrl");
                  sessionStorage.setItem("config_id", configId);
                  window.location.reload();
                }, 0);
              }}
              style={{
                padding: "6px 18px",
                backgroundColor: "#0063e5",
                color: "white",
                border: "1px solid #0063e5",
                borderRadius: "999px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Yes
            </button>
            <button
              onClick={() => toast.dismiss(t.id)}
              style={{
                padding: "6px 18px",
                backgroundColor: "#f0f0f0",
                color: "#111",
                border: "1px solid #ccc",
                borderRadius: "999px",
                cursor: "pointer",
              }}
            >
              No
            </button>
          </div>
        </div>
      ),
      {
        duration: 999999,
      }
    );
  }, [configId, setMessages, setStep, setUserName]);

  const handleShowMenu = useCallback(() => {
    setMenuVisible((prev) => !prev);
  }, []);

  const startElevenLabsSession = async () => {
    if (elConnected) return true;
    try {
      console.log("[EL] Requesting mic and starting session...");
      await conversation.startSession({ agentId: getAgentIdForAvatar(currentAvatar) });
      // Recording state and connected state are handled in onConnect
    } catch (err) {
      console.error("[EL] Failed to start session (Mic blocked or error):", err);
      setRecording(false);
      setPendingTextMessage(null);
      setMessages((prev) => [...prev, { type: "ai", text: "Koneksi gagal: Anda harus mengizinkan akses Mikrofon (Allow) di browser agar sistem ElevenLabs bisa terhubung." }]);
    }
  };
  const handleVoiceInput = async () => {
    if (!recording) {
      try {
        await startElevenLabsSession();
      } catch (err) {
        console.error("Microphone permission denied or failed:", err);
        setMessages((prev) => [...prev, { type: "ai", text: "Tolong izinkan akses mikrofon untuk memulai percakapan." }]);
      }
    } else {
      try {
        if (conversation.endSession) conversation.endSession();
      } catch (e) {}
      setRecording(false);
    }
  };

  const playAudio = useCallback(
    (audioUrl) => {
      const fullAudioUrl = `${BASE_URL}${audioUrl}`;

      if (audioPlayer) {
        audioPlayer.pause();
        audioPlayer.src = "";
      }

      const audio = new Audio(fullAudioUrl);
      audio.preload = "auto";
      setAudioPlayer(audio);

      audio.oncanplaythrough = () => {
        setVideoMode("talk");
        audio.play().catch((error) => {
          setVideoMode("idle");
          setMode("silent");
        });
      };

      audio.onended = () => {
        setVideoMode("idle");
        setAudioPlayer(null);
        setMode("silent");
      };

      audio.onerror = (error) => {
        setVideoMode("idle");
        setMode("silent");
      };

      audio.load();
    },
    [audioPlayer]
  );

  const handleVoiceInputClick = async () => {
    setIsVoiceInputActive(true);
    if (!recording) {
      await startElevenLabsSession();
    }
  };

  const handleVoiceCloseClick = () => {
    if (mode !== "talk" && mode !== "thinking") {
      const language = sessionStorage.getItem("language") || "English";
      const confirmationMessage =
        language === "Indonesia"
          ? "Apakah Anda yakin ingin keluar?"
          : "Are you sure you want to exit?";

      toast(
        (t) => (
          <div>
            <p>{confirmationMessage}</p>
            <div
              style={{
                background: "white",
                color: "#111",
                padding: "20px 0 0 0",
                borderRadius: "12px",
                width: "320px",
                fontSize: "14px",
                gap: "10px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <button
                onClick={() => {
                  toast.dismiss(t.id);
                  setIsVoiceInputActive(false);
                  setMode("silent");
                  try { if (conversation.endSession) conversation.endSession(); } catch(e) {} setRecording(false);
                  setElevenLabsTranscript(null);
                }}
                style={{
                  padding: "6px 18px",
                  backgroundColor: "#0063e5",
                  color: "white",
                  border: "1px solid #0063e5",
                  borderRadius: "999px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                {language === "Indonesia" ? "Ya" : "Yes"}
              </button>
              <button
                onClick={() => toast.dismiss(t.id)}
                style={{
                  padding: "6px 18px",
                  backgroundColor: "#f0f0f0",
                  color: "#111",
                  border: "1px solid #ccc",
                  borderRadius: "999px",
                  cursor: "pointer",
                }}
              >
                {language === "Indonesia" ? "Tidak" : "No"}
              </button>
            </div>
          </div>
        ),
        {
          duration: 999999,
          position: "top-center",
          id: "voice-exit-confirmation",
        }
      );
    }
  };

  useEffect(() => {
    switch (mode) {
      case "silent":
        setVideoMode("idle");
        setLoop(true);
        break;
      case "listen":
        setVideoMode("idle");
        setLoop(true);
        if (limitTimer) clearTimeout(limitTimer);
        const newlimitTimer = setTimeout(() => {
          setMode("thinking");
        }, 30000);
        setLimitTimer(newlimitTimer);
        break;
      case "thinking":
        setVideoMode("idle");
        setLoop(true);
        // DO NOT end the ElevenLabs session here!
        // ElevenLabs handles the thinking/response internally.
        // if (conversation.endSession) conversation.endSession();
        break;
      case "talk":
        setElevenLabsTranscript(null);
        setVideoMode("talk");
        setLoop(true);
        break;
      default:
        setVideoMode("idle");
        setLoop(true);
        break;
    }
  }, [mode]);

  const handleMicrophoneClick = () => {
    setMode((prevMode) => {
      switch (prevMode) {
        case "silent":
          return "listen";
        case "listen":
          if (
            elevenLabsTranscript === "" ||
            elevenLabsTranscript === null ||
            elevenLabsTranscript === undefined
          ) {
            return "listen";
          }
          return "thinking";
        case "thinking":
          if (
            elevenLabsTranscript === "" ||
            elevenLabsTranscript === null ||
            elevenLabsTranscript === undefined
          ) {
            return "listen";
          }
          return "talk";
        default:
          return "silent";
      }
    });
  };

  useEffect(() => {
    const checkMicPermission = async () => {
      try {
        await navigator.mediaDevices.getUserMedia({ audio: true });
        setMicPermission(true);
      } catch (error) {
        setMicPermission(false);
      }
    };

    if (isVoiceInputActive) {
      checkMicPermission();
    } else {
      setMicPermission(null);
    }
  }, [isVoiceInputActive]);

  const requestMicPermission = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      setMicPermission(true);
    } catch (error) {
      setMicPermission(false);
    }
  };

  const handleMicPermissionRequest = () => {
    if (micPermission === false) {
      alert(
        "Microphone access is blocked. Please enable it in your browser settings."
      );
      requestMicPermission();
    }
  };

  useEffect(() => {
    if (micPermission === false && isVoiceInputActive) {
      handleMicPermissionRequest();
    }
  }, [micPermission, isVoiceInputActive]);

  const normalizeLanguage = (language) => {
    const normalizedLanguage = (
      language ||
      sessionStorage.getItem("language") ||
      ""
    ).toLowerCase();

    if (normalizedLanguage === "en" || normalizedLanguage === "english") {
      return "English";
    } else if (
      normalizedLanguage === "id" ||
      normalizedLanguage === "indonesia"
    ) {
      return "Indonesia";
    }
    return "English";
  };

  const modeDetails = (language) => {
    const text = {
      English: {
        silent: "Tap to start talk",
        listen: "Tap after finish talking",
        thinking: "Thinking...",
      },
      Indonesia: {
        silent: "Ketuk untuk mulai berbicara",
        listen: "Ketuk setelah selesai berbicara",
        thinking: "Sedang berpikir...",
      },
    };

    const currentLanguage = normalizeLanguage(language);
    const currentText = text[currentLanguage] || text.English;

    return {
      silent: {
        text: currentText.silent,
        icon: <FaMicrophone />,
        textClassName: "text-silent",
        className: "microphone__button silent",
      },
      listen: {
        text: currentText.listen,
        icon: <FaMicrophone />,
        textClassName: "text-listen",
        className:
          micPermission === false
            ? "microphone__button not-listen"
            : "microphone__button listen pulse",
      },
      thinking: {
        text: currentText.thinking,
        icon: <AiOutlineLoading3Quarters className="loading-icon spinner" />,
        textClassName: "text-thinking",
        className: "microphone__button thinking",
      },
      talk: {
        text: aiResponse,
        icon: <HiMiniSpeakerWave className="heartbeat" />,
        textClassName: "text-talk",
        className: "microphone__button talk",
      },
    };
  };

  const { text, icon, className, textClassName } =
    modeDetails(sessionStorage.getItem("language"))[mode] || {};

  useEffect(() => {
    if (elConnected && pendingTextMessage && sendUserMessageRef.current) {
      console.log("[EL] Sending queued text message:", pendingTextMessage);
      try {
        sendUserMessageRef.current(pendingTextMessage);
      } catch (e) {
        console.error("[EL] sendUserMessage error:", e);
      }
      setPendingTextMessage(null);
    }
  }, [elConnected, pendingTextMessage]);

  const handleMessageSend = useCallback(
    async (message) => {
      if (!message || typeof message !== "string" || !message.trim()) {
        return;
      }
      if (message.trim()) {
        setMessages((prevMessages) => [
          ...prevMessages,
          { type: "user", text: message, userName: userName },
        ]);
        setInputMessage("");
        setIsLoading(true);

        if (elConnected && sendUserMessageRef.current) {
          console.log("[EL] Sending text message directly:", message);
          try {
            sendUserMessageRef.current(message);
          } catch (e) {
            console.error("[EL] sendUserMessage error:", e);
          }
        } else {
          console.log("[EL] Starting session automatically for text chat...");
          
          // Combine queued messages if user types multiple lines before connecting
          setPendingTextMessage((prev) => prev ? prev + " " + message : message);
          
          if (conversation.status !== "connecting") {
            await startElevenLabsSession();
          }
        }
      }
    },
    [userName, elConnected, conversation.status]
  );

  const handleNameSend = useCallback(() => {
    if (userName.trim() !== "") {
      setStep(5);
      setVideoMode("idle");

      const language = sessionStorage.getItem("language") || "English";
      const introductionMessage =
        language === "Indonesia"
          ? `Halo, nama saya ${userName}`
          : `Hi, my name is ${userName}`;

      handleMessageSend(introductionMessage);
    } else {
      alert("Name cannot be empty.");
    }
  }, [userName, handleMessageSend]);

  const handleNameInput = (e) => {
    const value = e.target.value;
    const regex = /^[a-zA-Z ]*$/;
    if (regex.test(value)) {
      setUserName(value);
    }
  };

  useEffect(() => {
    return () => {
      if (audioPlayer) {
        audioPlayer.pause();
        audioPlayer.src = "";
      }
    };
  }, [audioPlayer]);

  useEffect(() => {
    sessionStorage.setItem("step", JSON.stringify(step));
    sessionStorage.setItem("userName", userName);
    sessionStorage.setItem("messages", JSON.stringify(messages));
  }, [step, userName, messages]);

  const onIdle = () => {
    const lastMessage = messages[messages.length - 1];
    const textMessage = inActiveText;

    if (
      step === 5 &&
      currentVideo &&
      currentVideo.startsWith("/static/media/idle_") &&
      lastMessage &&
      !(lastMessage.type === "ai" && lastMessage.text === textMessage) &&
      !isLoading &&
      mode === "silent"
    ) {
      setIdleStatus(true);
    }
  };

  const onActive = () => {
    setIdleStatus(false);
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    onActive,
    timeout: 10_000,
    throttle: 1000,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 1000);

    return () => clearInterval(interval);
  }, [getRemainingTime]);

  const playNoActivityAudio = (audioFile) => {
    if (audioFile) {
      const audio = new Audio(audioFile);
      audio.play();
    }
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && idleStatus) {
        const audioFile = getAudioConfig();
        playNoActivityAudio(audioFile);
        setCurrentVideo(noActivityMessage);
        setLoop(false);
        setMessages((prevMessages) => [
          ...prevMessages,
          { type: "ai", text: inActiveText },
        ]);
        setTimeout(() => {
          setVideoMode("idle");
          setLoop(true);
        }, 5000);
      }
    };

    if (idleStatus) {
      if (document.visibilityState === "visible") {
        const audioFile = getAudioConfig();
        playNoActivityAudio(audioFile);
        setCurrentVideo(noActivityMessage);
        setLoop(false);
        setMessages((prevMessages) => [
          ...prevMessages,
          { type: "ai", text: inActiveText },
        ]);
        setTimeout(() => {
          setVideoMode("idle");
          setLoop(true);
        }, 5000);
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [idleStatus, noActivityMessage, inActiveText]);

  // const memoizedVideo = useMemo(
  //   () => (
  //     <ChromaKeyVideo
  //       className={`avatar-video-render ${fadeIn ? "fade-in" : ""}`}
  //       src={currentVideo}
  //       chromaColor={{ r: 300, g: 0, b: 0 }}
  //       loop={loop}
  //     />
  //   ),
  //   [currentVideo, loop, fadeIn]
  // );

  const handlePlayVideoManually = () => {
    setManualPlay(true);
    if (videoRef.current) {
      videoRef.current.muted = false;
      videoRef.current.play().catch((error) => {
        console.error("Error playing video manually:", error);
      });
    }
  };

  useEffect(() => {
    if (step !== 0 && videoRef.current && !manualPlay) {
      videoRef.current.play().catch((error) => {
        console.error("Autoplay failed:", error);
      });
    }
  }, [step, manualPlay]);

  const NewMemoizedVideo = useMemo(
    () => (
      <video
        className={`avatar_video--no-chromakey ${fadeIn ? "fade-in" : ""}`}
        ref={videoRef}
        src={currentVideo}
        autoPlay={step !== 0 && manualPlay}
        playsInline
        loop={loop}
        preload="auto"
        onEnded={step < 5 && step !== 4 ? handleAutoSkip : null}
        crossOrigin="anonymous"
        muted={step === 0 || videoMode === "talk"}
      />
    ),
    [currentVideo, loop, fadeIn, videoMode, step]
  );

  return (
    <div className="homepage">
      <div className="app__info">
        <div className="app__version">
          <p>{packageJson.version}</p>
        </div>
        <ConnectionTest elConnected={elConnected} micOn={recording && !micMuted} />
      </div>
      <Toaster />

      {step === 0 && !manualPlay && (
        <div className="play-video--overlay">
          <button
            className="play-video--button"
            onClick={handlePlayVideoManually}
          >
            {normalizeLanguage(sessionStorage.getItem("language")) ===
            "Indonesia"
              ? "Klik untuk mulai"
              : "Click to start"}
          </button>
        </div>
      )}

      {menuVisible && (
        <div className="menu-overlay" onClick={handleShowMenu}></div>
      )}
      {menuVisible ? (
        <Menu
          handleShowMenu={handleShowMenu}
          messages={messages}
          userName={userName}
        />
      ) : (
        step < 0 ||
        (step > 4 && (
          <div className="navbar">
            <div className="refresh-menu" onClick={handleRefresh}>
              <img src={refreshIcon} alt="Refresh" />
            </div>
            <div className="show-menu" onClick={handleShowMenu}>
              <img src={showMenuIcon} alt="Show Menu" />
            </div>
          </div>
        ))
      )}

      <div className="startpage__header">
        <img className="logo" src={fxmlogo} alt="FXMedia Logo" />
      </div>
      <div className="homepage__content">
        {NewMemoizedVideo}
        <div
          className="homepage__intro-popup"
          style={{ bottom: step >= 5 ? "calc(100px + env(safe-area-inset-bottom))" : "max(130px, 15vh)" }}
        >
          {step >= 5 ? (
            !isVoiceInputActive && (
              <BubbleChat
                messages={messages}
                isLoading={isLoading}
                userName={userName}
              />
            )
          ) : message ? (
            <div className="homepage__intro-popup--container">
              <img className="bg-popup--message" src={bgPopupMessage} alt="" />
              <p className="popup-message">{message}</p>
              {showNameInput && (
                <div className="container__name-input">
                  <input
                    id="name-input"
                    type="text"
                    placeholder={
                      normalizeLanguage(sessionStorage.getItem("language")) ===
                      "Indonesia"
                        ? "Masukkan nama Anda..."
                        : "Enter your name..."
                    }
                    value={userName}
                    onChange={handleNameInput}
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        handleNameSend();
                      }
                    }}
                  />
                  <div className="send-button" onClick={handleNameSend}>
                    <VscSend />
                  </div>
                </div>
              )}
              {showSkip && (
                <div className="popup__skip-button" onClick={handleSkip}>
                  {normalizeLanguage(sessionStorage.getItem("language")) ===
                  "Indonesia"
                    ? "lewati"
                    : "skip"}
                </div>
              )}
            </div>
          ) : null}
        </div>

        <div className="content__message-input">
          {!isVoiceInputActive ? (
            <div className="container__message-input">
              <div
                className={`voice-input__mic-toggle ${!elConnected ? "disabled" : micMuted ? "muted" : ""}`}
                onClick={() => {
                  if (!elConnected) return;
                  setMicMuted((prev) => !prev);
                }}
                title={!elConnected ? "Connect first" : micMuted ? "Unmute mic" : "Mute mic"}
              >
                {!elConnected || micMuted ? <FaMicrophoneSlash size={16} /> : <FaMicrophone size={16} />}
              </div>
              <input
                id="message-input"
                type="text"
                placeholder={
                  normalizeLanguage(sessionStorage.getItem("language")) ===
                  "Indonesia"
                    ? "Tanyakan sesuatu..."
                    : "Ask a question..."
                }
                className="message-input__input"
                value={inputMessage}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleMessageSend(inputMessage);
                  }
                }}
                onChange={(e) => setInputMessage(e.target.value)}
              />
              <div
                className="send-button"
                onClick={() => handleMessageSend(inputMessage)}
              >
                <VscSend />
              </div>
            </div>
          ) : (
            <div className="container__voice-input">
              {mode === "listen" && (
                <p className="voice-input__transcript">{elevenLabsTranscript}</p>
              )}
              <p className={textClassName}>{text}</p>
              <div className={className} onClick={handleVoiceInput}>
                {icon}
              </div>
              <div
                className="microphone__close-button"
                onClick={handleVoiceCloseClick}
              >
                <IoClose />
              </div>
            </div>
          )}
        </div>
        <div
          style={{
            zIndex: step < 5 ? 100 : 0,
            height: step < 5 ? "16vh" : "25vh",
          }}
          className="intro-overlay"
        ></div>
      </div>
    </div>
  );
}
